import StatutoryComponents from "../Statutary/StatutoryComponents";

export default function ProfessionalTaxSettings() {
  return <StatutoryComponents forcedTab="pt" />;
}
